<ng-template #loading>
  <div class="email-template-container automatic-send">
    <div class="title-bar">
      <h2>Sending Email</h2>
    </div>

    <div class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>

    <div class="navigation-buttons">
      <div><button mat-raised-button (click)="closeModal()">Exit</button></div>
      <div><button mat-raised-button color="primary" disabled>Send</button></div>
    </div>
  </div>
</ng-template>

<ng-template #automatedSend>
  <div class="email-template-container automatic-send">
    <div class="title-bar">
      <h2>Send Email With Attachment</h2>
    </div>

    <div class="email-action-group">
      <mat-form-field class="selection-input email-recipient" appearance="fill">
        <mat-label>Recipient Email</mat-label>
        <input matInput [formControl]="targetEmailFormControl">
        <mat-error *ngIf="targetEmailFormControl.hasError('required')">
          This field is required.
        </mat-error>
        <mat-error *ngIf="targetEmailFormControl.hasError('email')">
          Email format is invalid.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="email-instructions">You will be CCed on the email.  It typically takes less than 15 minutes for the email to be sent.</div>

    <div class="navigation-buttons">
      <div><button mat-raised-button (click)="closeModal()">Exit</button></div>
      <div>
        <button mat-raised-button color="primary"
                (click)="sendEmail()"
                [disabled]="sendIsDisabled$ | async">Send
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #manualSend>
  <div class="email-template-container">
    <div class="title-bar" data-test="SelectConversionTitleBar">
      <h2>Email Template and Attachment</h2>
    </div>

    <div class="email-action-group">
      <div>
        Edit, copy, and download the attachment
      </div>
      <div>
        <a mat-button color="primary" (click)="downloadExcel(data.rfxMetaData, data.products)">Download Attachment</a>
        <a mat-button
            color="primary"
            [cdkCopyToClipboard]="emailTemplate"
            #copyTooltip="matTooltip"
            matTooltip="Copied to Clipboard!"
            matTooltipPosition="above"
            [matTooltipDisabled]="true"
            (cdkCopyToClipboardCopied)="onCopyButtonClick($event)">
          Copy
        </a>
      </div>
    </div>

    <mat-dialog-content class="email-template-content">
      <textarea class="email-body" cols="800" rows="20" [(ngModel)]="emailTemplate">
      </textarea>
    </mat-dialog-content>

    <div class="navigation-buttons">
      <div><button mat-raised-button (click)="closeModal()">Exit</button></div>
      <div><button mat-raised-button color="primary" (click)="sent()">Sent</button></div>
    </div>
  </div>
</ng-template>

@if (this.isLoading$ | async) {
  <ng-container *ngTemplateOutlet="loading"></ng-container>
} @else if (this.automatedSendEnabled) {
  <ng-container *ngTemplateOutlet="automatedSend"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="manualSend"></ng-container>
}
